// import PropTypes from "prop-types";
// import React from "react";
// import {
//   Row,
//   Col,
//   Alert,
//   Card,
//   CardBody,
//   Container,
//   FormFeedback,
//   Input,
//   Label,
//   Form,
// } from "reactstrap";

// //redux
// import { useSelector, useDispatch } from "react-redux";

// import { Link } from "react-router-dom";
// import withRouter from "../../Components/Common/withRouter";

// // Formik Validation
// import * as Yup from "yup";
// import { useFormik } from "formik";

// // action
// import { userForgetPassword } from "../../slices/thunks";

// // import images
// // import profile from "../../assets/images/bg.png";
// import logoLight from "../../assets/images/logo-light.png";
// // import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
// import { createSelector } from "reselect";

// const ForgetPasswordPage = (props) => {
//   const dispatch = useDispatch();

//   const validation = useFormik({
//     // enableReinitialize : use this flag when initial values needs to be changed
//     enableReinitialize: true,

//     initialValues: {
//       username: "",
//     },
//     validationSchema: Yup.object({
//       username: Yup.string().required("Please Enter Your Email"),
//     }),
//     onSubmit: (values) => {
//       dispatch(userForgetPassword(values, props.history));
//     },
//   });

//   const selectLayoutState = (state) => state.ForgetPassword;
//   const selectLayoutProperties = createSelector(selectLayoutState, (state) => ({
//     forgetError: state.forgetError,
//     forgetSuccessMsg: state.forgetSuccessMsg,
//   }));
//   // Inside your component
//   const { forgetError, forgetSuccessMsg } = useSelector(selectLayoutProperties);

//   document.title = "Reset Password";
//   return (
//     // <ParticlesAuth>
//     <div className="auth-page-content mt-lg-5">
//       <Container>
//         {/* <Row>
//             <Col lg={12}>
//               <div className="text-center mt-sm-5 mb-4 text-white-50">
//                 <div>
//                   <Link to="/" className="d-inline-block auth-logo">
//                     <img src={logoLight} alt="" height="20" />
//                   </Link>
//                 </div>
//                 <p className="mt-3 fs-15 fw-medium">Premium Admin & Dashboard Template</p>
//               </div>
//             </Col>
//           </Row> */}

//         <Row className="justify-content-center">
//           <Col md={8} lg={6} xl={5}>
//             <Card className="mt-4">
//               <CardBody className="p-4">
//                 <div className="text-center mt-2">
//                   <h5 className="text-success">Reset Password?</h5>
//                   {/* <p className="text-muted">Reset password with velzon</p> */}

//                   <lord-icon
//                     src="https://cdn.lordicon.com/rhvddzym.json"
//                     trigger="loop"
//                     colors="primary:#0ab39c"
//                     className="avatar-xl"
//                     style={{ width: "120px", height: "120px" }}
//                   ></lord-icon>
//                 </div>

//                 <Alert
//                   className="border-0 alert-warning text-center mb-2 mx-2"
//                   role="alert"
//                 >
//                   Enter your email and instructions will be sent to you!
//                 </Alert>
//                 <div className="p-2">
//                   {forgetError && forgetError ? (
//                     <Alert color="danger" style={{ marginTop: "13px" }}>
//                       {forgetError}
//                     </Alert>
//                   ) : null}
//                   {forgetSuccessMsg ? (
//                     <Alert color="success" style={{ marginTop: "13px" }}>
//                       {forgetSuccessMsg}
//                     </Alert>
//                   ) : null}
//                   <Form
//                     onSubmit={(e) => {
//                       e.preventDefault();
//                       validation.handleSubmit();
//                       return false;
//                     }}
//                   >
//                     <div className="mb-4">
//                       <Label className="form-label">Email</Label>
//                       <Input
//                         name="username"
//                         className="form-control"
//                         placeholder="Enter email"
//                         type="email"
//                         onChange={validation.handleChange}
//                         onBlur={validation.handleBlur}
//                         value={validation.values.username || ""}
//                         invalid={
//                           validation.touched.username &&
//                           validation.errors.username
//                             ? true
//                             : false
//                         }
//                       />
//                       {validation.touched.username &&
//                       validation.errors.username ? (
//                         <FormFeedback type="invalid">
//                           <div>{validation.errors.username}</div>
//                         </FormFeedback>
//                       ) : null}
//                     </div>

//                     <div className="text-center mt-4">
//                       <button className="btn btn-success w-100" type="submit">
//                         Send Reset Link
//                       </button>
//                     </div>
//                   </Form>
//                 </div>
//               </CardBody>
//             </Card>

//             <div className="mt-4 text-center">
//               <p className="mb-0">
//                 Wait, I remember my password...{" "}
//                 <Link
//                   to="/login"
//                   className="fw-semibold text-primary text-decoration-underline"
//                 >
//                   {" "}
//                   Click here{" "}
//                 </Link>{" "}
//               </p>
//             </div>
//           </Col>
//         </Row>
//       </Container>
//     </div>
//     // </ParticlesAuth>
//   );
// };

// ForgetPasswordPage.propTypes = {
//   history: PropTypes.object,
// };

// export default withRouter(ForgetPasswordPage);

import PropTypes from "prop-types";
import React, { useState } from "react";
import {
  Row,
  Col,
  Alert,
  Card,
  CardBody,
  Container,
  FormFeedback,
  Input,
  Label,
  Form,
} from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link, useNavigate } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { userForgetPassword, verifyOtpThunk } from "../../slices/thunks";

// import images
// import profile from "../../assets/images/bg.png";
import logoLight from "../../assets/images/logo-light.png";
// import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { createSelector } from "reselect";

const ForgetPasswordPage = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showOtp, setShowOtp] = useState(false);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      username: "",
      otp: "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Please Enter Your Email"),
      otp: showOtp ? Yup.string().required("Please enter OTP") : Yup.string(),
    }),
    onSubmit: async (values) => {
      if (!showOtp) {
        const success = await dispatch(
          userForgetPassword({ username: values.username })
        );

        if (success) {
          setShowOtp(true);
        }
      } else {
        const verified = await dispatch(
          verifyOtpThunk(
            {
              username: values.username,
              otp: values.otp,
            },
            props.history
          )
        );
        if (verified) {
          navigate("/reset-password", {
            state: { username: values.username },
          });
        }
      }
    },
  });

  const selectLayoutState = (state) => state.ForgetPassword;
  const selectLayoutProperties = createSelector(selectLayoutState, (state) => ({
    forgetError: state.forgetError,
    forgetSuccessMsg: state.forgetSuccessMsg,
  }));
  // Inside your component
  const { forgetError, forgetSuccessMsg } = useSelector(selectLayoutProperties);

  document.title = "Reset Password";
  return (
    // <ParticlesAuth>
    <div className="auth-page-content mt-lg-5">
      <Container>
        {/* <Row>
            <Col lg={12}>
              <div className="text-center mt-sm-5 mb-4 text-white-50">
                <div>
                  <Link to="/" className="d-inline-block auth-logo">
                    <img src={logoLight} alt="" height="20" />
                  </Link>
                </div>
                <p className="mt-3 fs-15 fw-medium">Premium Admin & Dashboard Template</p>
              </div>
            </Col>
          </Row> */}

        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={5}>
            <Card className="mt-4">
              <CardBody className="p-4">
                <div className="text-center mt-2">
                  <h5 className="text-success">Reset Password?</h5>
                  {/* <p className="text-muted">Reset password with velzon</p> */}

                  <lord-icon
                    src="https://cdn.lordicon.com/rhvddzym.json"
                    trigger="loop"
                    colors="primary:#0ab39c"
                    className="avatar-xl"
                    style={{ width: "120px", height: "120px" }}
                  ></lord-icon>
                </div>

                <Alert
                  className="border-0 alert-warning text-center mb-2 mx-2"
                  role="alert"
                >
                  Enter your email and instructions will be sent to you!
                </Alert>
                <div className="p-2">
                  {forgetError && forgetError ? (
                    <Alert color="danger" style={{ marginTop: "13px" }}>
                      {forgetError}
                    </Alert>
                  ) : null}
                  {forgetSuccessMsg ? (
                    <Alert color="success" style={{ marginTop: "13px" }}>
                      {forgetSuccessMsg}
                    </Alert>
                  ) : null}
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    {/* <div className="mb-4">
                      <Label className="form-label">Email</Label>
                      <Input
                        name="username"
                        className="form-control"
                        placeholder="Enter email"
                        type="email"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.username || ""}
                        invalid={
                          validation.touched.username &&
                          validation.errors.username
                            ? true
                            : false
                        }
                      />
                      {validation.touched.username &&
                      validation.errors.username ? (
                        <FormFeedback type="invalid">
                          <div>{validation.errors.username}</div>
                        </FormFeedback>
                      ) : null}
                    </div> */}

                    {/* EMAIL FIELD */}
                    {!showOtp && (
                      <div className="mb-4">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="username"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.username}
                          invalid={
                            validation.touched.username &&
                            validation.errors.username
                              ? true
                              : false
                          }
                        />
                        <FormFeedback>
                          {validation.errors.username}
                        </FormFeedback>
                      </div>
                    )}

                    {/* OTP FIELD */}
                    {showOtp && (
                      <div className="mb-4">
                        <Label className="form-label">Enter OTP</Label>
                        <Input
                          name="otp"
                          className="form-control"
                          placeholder="Enter OTP"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.otp}
                          invalid={
                            validation.touched.otp && validation.errors.otp
                              ? true
                              : false
                          }
                        />
                        <FormFeedback>{validation.errors.otp}</FormFeedback>
                      </div>
                    )}

                    <div className="text-center mt-4">
                      <button className="btn btn-success w-100" type="submit">
                        {!showOtp ? "Send OTP" : "Verify OTP"}
                      </button>
                    </div>
                  </Form>
                </div>
              </CardBody>
            </Card>

            <div className="mt-4 text-center">
              <p className="mb-0">
                Wait, I remember my password...{" "}
                <Link
                  to="/login"
                  className="fw-semibold text-primary text-decoration-underline"
                >
                  {" "}
                  Click here{" "}
                </Link>{" "}
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
    // </ParticlesAuth>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
